import { Type } from '@sinclair/typebox';
export const SyncCustomerInvoicesResponseSchema = Type.Object({
    success: Type.Boolean(),
});
